var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ios8-switch ch2-nice-checkbox",class:{'checked': _vm.value, 'error': _vm.error},on:{"click":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }